import { render, staticRenderFns } from "./Segmentos.vue?vue&type=template&id=1fe9123c&scoped=true"
import script from "./Segmentos.vue?vue&type=script&lang=js"
export * from "./Segmentos.vue?vue&type=script&lang=js"
import style0 from "./Segmentos.vue?vue&type=style&index=0&id=1fe9123c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9123c",
  null
  
)

export default component.exports